import React from "react";
import { School, UserRound, BookOpen, TrendingUp, Sparkles, Award } from "lucide-react";

const items = [
  { icon: UserRound, title: "Veli Hesabı Oluştur", desc: "Cep telefonuyla SMS doğrulaması yaparak saniyeler içinde hesap açın." },
  { icon: School, title: "Çocuk Profillerini Ekle", desc: "Tek hesap altında tüm çocuklarınızı ekleyip ayrı ayrı yönetin." },
  { icon: BookOpen, title: "Sınav & Başvuru", desc: "Bursluluk başvuruları ve deneme sınavlarına katılım tek panelden." },
  { icon: TrendingUp, title: "Performans Takibi", desc: "Deneme sınavlarındaki gelişimi ders bazında görüntüleyin." },
  { icon: Sparkles, title: "AI Tercih Danışmanlığı", desc: "Puanınıza göre zorlayıcı, gerçekçi ve güvenli önerilerinizi alın." },
  { icon: Award, title: "Okul Davetleri", desc: "Başarılı öğrenciler okullardan burs teklifi alır." },
];

export default function HowItWorks() {
  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16" data-testid="how-it-works-page">
      <div className="max-w-2xl">
        <div className="overline text-accent mb-3">Nasıl Çalışır</div>
        <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tight">
          SanoStudent süreci basit ve şeffaf.
        </h1>
        <p className="text-muted-foreground mt-4 leading-relaxed">
          Aşağıdaki adımları takip ederek özel okul bursluluk fırsatlarını değerlendirebilir,
          çocuğunuzun akademik gelişimini bilimsel verilerle izleyebilirsiniz.
        </p>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mt-12">
        {items.map((it, i) => (
          <div key={it.title} className="p-6 rounded-xl border border-border bg-card">
            <div className="text-6xl font-display font-black text-accent/15 leading-none mb-2">0{i + 1}</div>
            <it.icon className="h-6 w-6 text-primary mb-3" />
            <div className="font-display font-bold text-lg mb-1">{it.title}</div>
            <div className="text-sm text-muted-foreground leading-relaxed">{it.desc}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
